"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
const ramda_adjunct_1 = require("ramda-adjunct");
// This is actually typed more strictly than the implementation of `pickThenRename`,
// but due to `curry` breaking TypeScript inference, this doesn't cause any typing
// errors.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const pickThenRename = (keyNames, keyNamesMap, obj) => (0, ramda_adjunct_1.renameKeys)(keyNamesMap, (0, ramda_1.pick)(keyNames, obj));
exports.default = (0, ramda_1.curry)(pickThenRename);
